export default __webpack_public_path__ + "static/media/google.70434f66.svg";